<template lang="html">
  <div>
    <TermsList   v-bind:queryParams="queryParams" v-bind:currentTab="currentTab" v-bind:fullDate="fullDate" v-bind:fieldobj="fieldobj"/>
  </div>
</template>

<script>


import DatePicker from 'vue2-datepicker';
import cSwitch from '../../../../components/Switch';
import TermsList from "./TermsList";
const moment = require('moment');

export default {
  name: 'TermsManagementList',
  components: {
    TermsList,
    cSwitch,
    DatePicker,
  },
  props: {
    currentTab: {
      type: String
    },
    fieldobj: {
      type: Object
    },
  },
  data () {
    return {
      fullDate: [],
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },

      queryParams: {
        term_type       : 'terms',
        use_yn          : '',
        start_date      : '',
        end_date        : '',
      },
    }
  },
  computed: {
    listRows () {
      return this.items.length
    }
  },
  mounted: function () {

  },

  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  }
}


</script>



// WEBPACK FOOTER //
// src/views/site/terms/component/TermsManagementList.vue